export const GRAFICO_COLOR_A = '#5888ab';
export const GRAFICO_COLOR_B = '#8c4e92';

export interface PieChartData {
  labels: string[];
  datasets: { data: number[]; backgroundColor: string[] }[];
}

export function buildSexoPie(hombres: number, mujeres: number): PieChartData {
  return {
    labels: ['Hombres', 'Mujeres'],
    datasets: [
      {
        data: [hombres, mujeres],
        backgroundColor: [GRAFICO_COLOR_A, GRAFICO_COLOR_B],
      },
    ],
  };
}

export interface ReunionCounts {
  reu0: number;
  reu1: number;
  reu2: number;
  reu3: number;
  reu4: number;
  reu5: number;
  reu6: number;
  reu7: number;
  reu8: number;
  reuVar: number;
  noReu: number;
}

const REUNION_ITEMS: { key: keyof ReunionCounts; label: string; color: string; minCulto?: number }[] = [
  { key: 'reu1', label: '1er Reunión', color: '#5888ab', minCulto: 1 },
  { key: 'reu2', label: '2da Reunión', color: '#8c4e92', minCulto: 2 },
  { key: 'reu3', label: '3ra Reunión', color: '#002d64b0', minCulto: 3 },
  { key: 'reu4', label: '4ta Reunión', color: '#4C6C94', minCulto: 4 },
  { key: 'reu5', label: '5ta Reunión', color: '#7998B4', minCulto: 5 },
  { key: 'reu6', label: '6ta Reunión', color: '#A7C4D4', minCulto: 6 },
  { key: 'reu7', label: '7ma Reunión', color: '#b8e7ef', minCulto: 7 },
  { key: 'reu8', label: '8va Reunión', color: '#9eecf9', minCulto: 8 },
];

export function buildReunionPie(counts: ReunionCounts, cantCulto: number): PieChartData {
  const labels: string[] = [];
  const data: number[] = [];
  const backgroundColor: string[] = [];
  let sinInformar = counts.reu0 ?? 0;

  for (const item of REUNION_ITEMS) {
    const value = counts[item.key] ?? 0;
    if ((item.minCulto ?? 1) <= cantCulto) {
      labels.push(item.label);
      data.push(value);
      backgroundColor.push(item.color);
    } else {
      sinInformar += value;
    }
  }

  labels.push('Multiples Reuniones', 'No Asistirán', 'Sin informar');
  data.push(counts.reuVar ?? 0, counts.noReu ?? 0, sinInformar);
  backgroundColor.push('#62c15c', '#d57171', '#A7C4D4');

  return { labels, datasets: [{ data, backgroundColor }] };
}

export function buildBautismoPie(bautizados: number, noBautizados: number): PieChartData {
  return {
    labels: ['Bautizados', 'No Bautizados'],
    datasets: [
      {
        data: [bautizados, noBautizados],
        backgroundColor: [GRAFICO_COLOR_A, GRAFICO_COLOR_B],
      },
    ],
  };
}
